import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = resource => {
  return [
    <MenuItem
      primaryText='Edit'
      key='edit'
      value={`/events/session-sales/${resource.session_sale_id}/reservations/${resource.id}/edit`}
    />
  ]
}

export default buildMenuItems
